module.exports = __webpack_public_path__ + "media/images/lb/166-13b71621443766a37e0a307fdc89b820.svg";